import type { ReactNode } from "react";
import { useAuth } from "../auth";

export function AdminOnlyView({ role, children }: { role: string | undefined; children: ReactNode }) {
  return role === "admin" ? <>{children}</> : <p className="text-sm text-slate-500">Admins only.</p>;
}

export function AdminOnly({ children }: { children: ReactNode }) {
  const { me } = useAuth();
  return <AdminOnlyView role={me?.user.role}>{children}</AdminOnlyView>;
}

export const adminPage = (C: () => JSX.Element) => () => <AdminOnly><C /></AdminOnly>;
